import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { callGtmCheckout } from '@/utils/Controllers/GTM/Operations/Checkout';

const useGtmCheckout = ({
  entries,
  fetchLoading,
  isAnonymousCheckout = false,
  gyUid,
  step = 1,
  email = '',
}) => {
  useEffect(() => {
    if (!fetchLoading && !_isEmpty(entries)) {
      callGtmCheckout({ entries, gyUid, email, step });
    }
  }, [fetchLoading, isAnonymousCheckout]);
};

export default useGtmCheckout;
